import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UfFlowStepDto} from "../../../model/dto/entity/uf-flow-step.dto";
import {UfStepStatusEnum} from "../../../model/dto/enum/uf-step-status.enum";
import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
    providedIn: 'root'
})
export class UfFlowStepService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/uf/flowSteps');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

    public changeStepStatus(step: UfFlowStepDto, status: UfStepStatusEnum): Observable<UfFlowStepDto> {
        const updateDto = new UfFlowStepDto();
        updateDto.id = step.id;
        updateDto.status = status;
        return <Observable<UfFlowStepDto>>this.update(updateDto);
    }
}
